import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { AdvancePreferencesAPIActions } from '../actions/advance-preferences.actions';
import { AdvancePreferencesFeatureState } from '../interfaces/shared.interface';

const initialState: AdvancePreferencesFeatureState = {
  isLoaded: false,
  advanceShiftsEnabled: false,
  advanceShiftsOptInEnabled: false,
};

const reducer: ActionReducer<AdvancePreferencesFeatureState> = createReducer(
  initialState,
  on(
    AdvancePreferencesAPIActions.loadedAdvancePreferencesSuccessfully,
    (state, { advancePreferences }): AdvancePreferencesFeatureState => ({
      ...advancePreferences,
      isLoaded: true,
    }),
  ),
);

export function advancePreferencesReducer(
  state: AdvancePreferencesFeatureState = initialState,
  action: Action,
): AdvancePreferencesFeatureState {
  return reducer(state, action);
}
